"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Media = /*#__PURE__*/function () {
  function Media(component) {
    (0, _classCallCheck2["default"])(this, Media);
    this.dom = {
      $component: component,
      $object: component.querySelector('.js-media-object'),
      $preloadObject: component.querySelector('.js-media-object-preload'),
      $video: component.querySelector('.js-media-video')
    };
    this.state = {
      src: false,
      once: false,
      loaded: false,
      notify: component.dataset.notify,
      loadedTimeout: 65,
      loadedClass: 'is-loaded',
      supportsObjectFit: 'objectFit' in document.documentElement.style && !/Edge/.test(navigator.userAgent),
      shouldLoadVideo: !('ontouchstart' in document.documentElement) && window.outerWidth > 768,
      shouldLoadMobileSrc: window.outerWidth < 768,
      supportsIntersectionObserver: 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype,
      observer: false,
      observerConfig: {
        rootMargin: '250px',
        threshold: 0.01
      }
    };
    this.mount();
  }

  (0, _createClass2["default"])(Media, [{
    key: "mount",
    value: function mount() {
      var self = this;
      var dom = this.dom,
          state = this.state; //console.log('Media : mount', this);

      if (dom.$preloadObject) {
        self.load();
      } else if (!state.supportsIntersectionObserver) {
        self.load();
      } else {
        self.observe();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state; //console.log('Media : unmount', this);
    }
  }, {
    key: "observe",
    value: function observe() {
      //console.log('Media : observe', this);
      var state = this.state;
      state.observer = new IntersectionObserver(this.onIntersection.bind(this), state.observerConfig);
      [this.dom.$component].forEach(function (element) {
        return state.observer.observe(element);
      });
    }
  }, {
    key: "onIntersection",
    value: function onIntersection(entries) {
      var state = this.state; //console.log('Media : onIntersection', this);

      if (!state.once) {
        var entry = entries[0];
        var inview = entry.intersectionRatio > 0;

        if (inview) {
          this.load();
          state.once = true;
          state.observer.unobserve(entry.target);
        }
      }
    }
  }, {
    key: "getSrcKey",
    value: function getSrcKey() {
      var dom = this.dom,
          state = this.state;
      var hasMobileKey = Object.keys(dom.$object.dataset).indexOf('mobileSrc') !== -1;
      var key = hasMobileKey && state.shouldLoadMobileSrc ? 'data-mobile-src' : 'data-src';
      return key;
    }
  }, {
    key: "load",
    value: function load() {
      var dom = this.dom,
          state = this.state;
      var key = this.getSrcKey();
      var src = dom.$object.getAttribute(key) || false;
      var image = new Image();

      if (src) {
        this.update(src);
        this.setLoaded();
      }

      if (dom.$video && state.shouldLoadVideo && state.supportsObjectFit) {
        this.loadVideo();
      } else {
        this.removeVideo();
      }
    }
  }, {
    key: "loadVideo",
    value: function loadVideo() {
      var _this = this;

      var self = this;
      var dom = this.dom;
      var sources = dom.$video.getElementsByTagName('source');
      Array.from(sources).forEach(function (source) {
        var src = source.getAttribute('data-src') || false;

        if (src) {
          source.setAttribute('src', src);
          source.removeAttribute('data-src');

          _this.playVideo();
        }
      });
    }
  }, {
    key: "playVideo",
    value: function playVideo() {
      //console.log('Media : playVideo', this);
      var video = dom.$video;
      var playPromise = video.play();
      video.load();

      if (playPromise !== undefined) {
        playPromise.then(function () {
          video.pause();
        })["catch"](function (error) {//console.log('Media : playVideo', error);
        });
      }
    }
  }, {
    key: "removeVideo",
    value: function removeVideo() {
      var dom = this.dom;

      if (dom.$video) {
        dom.$video.remove();
        dom.$video = false;
      }
    }
  }, {
    key: "update",
    value: function update(src) {
      var dom = this.dom,
          state = this.state; //console.log('Media : update', this);

      if (state.src !== src) {
        state.src = src;

        if (dom.$object.tagName == 'IMG') {
          dom.$object.setAttribute('src', state.src);
        } else {
          dom.$object.style.backgroundImage = "url(".concat(state.src, ")");
        }
      }
    }
  }, {
    key: "setLoaded",
    value: function setLoaded() {
      var _this2 = this;

      var state = this.state; //console.log('Media : setLoaded', this);

      if (!state.loaded) {
        state.loaded = true;
        setTimeout(function () {
          _this2.dom.$component.classList.add(state.loadedClass);
        }, state.loadedTimeout);
      }
    }
  }]);
  return Media;
}();

exports["default"] = Media;